import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
  color: string;
}

const imageMap: Record<string, string> = {
  'cat-action': 'https://readdy.ai/api/search-image?query=Dynamic%20action%20game%20illustration%20with%20explosive%20energy%20and%20warrior%20silhouettes%2C%20warm%20orange%20and%20red%20gradient%20background%2C%20modern%20digital%20art%20style&width=600&height=360&seq=cat-action&orientation=landscape',
  'cat-rpg': 'https://readdy.ai/api/search-image?query=Fantasy%20RPG%20illustration%20with%20magical%20realm%20and%20mystical%20characters%2C%20warm%20golden%20amber%20gradient%20background%2C%20modern%20digital%20art%20style&width=600&height=360&seq=cat-rpg&orientation=landscape',
  'cat-strategy': 'https://readdy.ai/api/search-image?query=Strategic%20board%20game%20digital%20illustration%20with%20tactical%20map%20and%20chess%20elements%2C%20warm%20earthy%20gradient%20background%2C%20modern%20digital%20art&width=600&height=360&seq=cat-strategy&orientation=landscape',
  'cat-simulation': 'https://readdy.ai/api/search-image?query=City%20building%20simulation%20illustration%20with%20architectural%20elements%20and%20construction%2C%20warm%20terra%20cotta%20gradient%20background%2C%20modern%20digital%20art&width=600&height=360&seq=cat-simulation&orientation=landscape',
  'cat-casual': 'https://readdy.ai/api/search-image?query=Playful%20casual%20game%20illustration%20with%20colorful%20cute%20characters%20and%20fun%20elements%2C%20warm%20bright%20gradient%20background%2C%20modern%20digital%20art&width=600&height=360&seq=cat-casual&orientation=landscape',
  'cat-indie': 'https://readdy.ai/api/search-image?query=Independent%20game%20studio%20illustration%20with%20creative%20artistic%20design%20and%20unique%20style%2C%20warm%20artistic%20gradient%20background%2C%20modern%20digital%20art&width=600&height=360&seq=cat-indie&orientation=landscape',
};

export default function CategoryCard({
  slug,
  name,
  description,
  icon,
  imageSeq,
  color,
}: CategoryCardProps) {
  const imgSrc = imageMap[imageSeq] || imageMap['cat-action'];

  return (
    <Link
      to={`/category/${slug}`}
      className="block group cursor-pointer"
    >
      <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300">
        <div className="relative w-full h-40 overflow-hidden">
          <img
            src={imgSrc}
            alt={name}
            title={`${name} - 黄油游戏下载`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className={`absolute inset-0 bg-gradient-to-br ${color} opacity-60`}></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-14 h-14 flex items-center justify-center bg-background-50/90 rounded-full">
              <i className={`${icon} text-2xl text-primary-500`}></i>
            </div>
          </div>
        </div>
        <div className="p-4 text-center">
          <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
            {name}
          </h3>
          <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </Link>
  );
}